import React from "react";
import { ReactComponent as Placeholder } from "./assets/user.svg";

export default function ProfileAvatar({ src }) {
  return (
    <div style={{ textAlign: "center", marginTop: 20 }}>
      {!!src ? (
        <img src={src} style={{ width: 70, height: 70, borderRadius: "50%" }} />
      ) : (
        <Placeholder style={{ width: 70, height: 70 }} />
      )}
    </div>
  );
}
